import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
  const mainGallery = document.getElementById('main-gallery');
  const thumbnailGallery = document.getElementById('thumbnail-gallery');
  const eventGallery = document.querySelector('.event-gallery');
  const expandBtn = document.querySelector('.gallery-expand-btn');

  let main = null;
  let thumbnails = null;

  // Set proper sizes attribute for gallery images based on actual rendered size
  function setSizesAttribute() {
    const viewportWidth = window.innerWidth;

    // Main gallery images
    if (mainGallery) {
      const mainImages = mainGallery.querySelectorAll('img');
      mainImages.forEach(img => {
        // Measure the actual displayed width of the image container
        const container = img.closest('.splide__slide') || img.parentElement;
        if (container) {
          const displayedWidth = container.clientWidth || container.offsetWidth;

          // Check if gallery is expanded
          const isExpanded = eventGallery && eventGallery.classList.contains('expanded');

          if (isExpanded) {
            // In expanded mode, use full viewport
            img.setAttribute('sizes', '100vw');
          } else {
            // Calculate the percentage of viewport this image occupies
            const viewportPercentage = (displayedWidth / viewportWidth) * 100;

            // Create responsive sizes attribute
            // This tells the browser: at different screen widths, how much space does this image take?
            let sizesValue;

            if (viewportWidth <= 768) {
              // Mobile: image takes most of the viewport
              sizesValue = `${Math.round(viewportPercentage)}vw`;
            } else if (viewportWidth <= 1200) {
              // Tablet: image takes a percentage of viewport
              sizesValue = `${Math.round(viewportPercentage)}vw`;
            } else {
              // Desktop: use fixed max width or percentage, whichever is smaller
              sizesValue = `(min-width: 1200px) ${displayedWidth}px, ${Math.round(viewportPercentage)}vw`;
            }

            img.setAttribute('sizes', sizesValue);
          }
        }
      });
    }

    // Thumbnail gallery images
    if (thumbnailGallery) {
      const thumbnailImages = thumbnailGallery.querySelectorAll('img');
      thumbnailImages.forEach(img => {
        const container = img.closest('.splide__slide') || img.parentElement;
        if (container) {
          const displayedWidth = container.clientWidth || container.offsetWidth;
          const viewportPercentage = (displayedWidth / viewportWidth) * 100;

          // Thumbnails: use exact width or viewport percentage
          img.setAttribute('sizes', `${Math.round(viewportPercentage)}vw`);
        }
      });
    }
  }

  // Call after a short delay to ensure layout is complete
  setTimeout(() => {
    setSizesAttribute();
  }, 100);

  // Recalculate sizes on window resize (debounced)
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      setSizesAttribute();
    }, 250);
  });

  if (mainGallery) {
    main = new Splide(mainGallery, {
      type: 'slide',
      rewind: true,
      pagination: false,
      arrows: true,
      keyboard: true,
      height: 'auto',
    });

    if (thumbnailGallery) {
      thumbnails = new Splide(thumbnailGallery, {
        fixedWidth: 120,
        fixedHeight: 90,
        gap: 10,
        rewind: true,
        pagination: false,
        isNavigation: true,
        arrows: false,
        focus: 'center',
        breakpoints: {
          600: {
            fixedWidth: 80,
            fixedHeight: 60,
          },
        },
      });

      main.sync(thumbnails);
      thumbnails.mount();
    }

    main.mount();
  }

  // Helper function to refresh galleries
  function refreshGalleries() {
    if (main) {
      // Use setTimeout to ensure DOM has updated
      setTimeout(() => {
        main.refresh();
        if (thumbnails) {
          thumbnails.refresh();
        }
      }, 50);
    }
  }

  // Gallery expand/collapse functionality
  if (expandBtn && eventGallery) {
    expandBtn.addEventListener('click', function () {
      const isExpanded = eventGallery.classList.contains('expanded');

      if (isExpanded) {
        eventGallery.classList.remove('expanded');
        document.body.classList.remove('gallery-expanded');
      } else {
        eventGallery.classList.add('expanded');
        document.body.classList.add('gallery-expanded');
      }

      // Refresh galleries and recalculate sizes after toggle
      refreshGalleries();
      setTimeout(() => {
        setSizesAttribute();
      }, 100);
    });

    // Close button functionality
    const closeBtn = document.createElement('button');
    closeBtn.className = 'gallery-close-btn';
    closeBtn.setAttribute('aria-label', 'Close gallery');
    closeBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    `;
    eventGallery.appendChild(closeBtn);

    closeBtn.addEventListener('click', function () {
      eventGallery.classList.remove('expanded');
      document.body.classList.remove('gallery-expanded');

      // Refresh galleries and recalculate sizes after closing
      refreshGalleries();
      setTimeout(() => {
        setSizesAttribute();
      }, 100);
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && eventGallery.classList.contains('expanded')) {
        eventGallery.classList.remove('expanded');
        document.body.classList.remove('gallery-expanded');

        // Refresh galleries and recalculate sizes after closing
        refreshGalleries();
        setTimeout(() => {
          setSizesAttribute();
        }, 100);
      }
    });
  }
});
